/* eslint-disable max-len */
import { CouponState } from '@tencent/wphk-act-base-types';
import ScanGift from '../../scan-gift/scan-gift.vue';
import { computed, ref } from 'vue-demi';
import { getUrlHasC2CShareCode } from '../business';

export const useC2cScanGift = () => {
  /** 扫码有礼组件 */
  const scanGift = ref<InstanceType<typeof ScanGift> | null>(null);
  const scanGiftCouponList = ref<any>([]);
  const isScanGiftShow = ref(false);
  const isScanGiftInited = ref(false);

  const scanGiftExt = { fchannel: getUrlHasC2CShareCode() ? 'share' : '' };

  function isReceiveCoupon(coupon) {
    return [CouponState.expired, CouponState.used, CouponState.received].includes(coupon.couponState);
  }

  /** 扫码有礼的券都被领取 */
  const isAllScanGiftCouponReceived = computed(() => scanGiftCouponList.value.every(item => isReceiveCoupon(item)));

  /** 扫码有礼的券都没被领取 */
  const isAllScanGiftCouponNotReceived = computed(() => scanGiftCouponList.value.every(item => !isReceiveCoupon(item)));

  async function receiveScanGiftCoupon(coupon) {
    if (Array.isArray(coupon)) {
      /** 如果是数组，则执行领全部券 */
      (scanGift.value as any)?.receiveAllCoupon();
    } else {
      /** 如果是数组，则执行领对应券 */
      (scanGift.value as any)?.receiveCoupon(coupon);
    }
  }

  function onShowState(isShow) {
    isScanGiftShow.value = isShow;
  }

  function onCompReady(data) {
    isScanGiftInited.value = true;
    scanGiftCouponList.value = data.fixedCouponDetailList;
  }

  return {
    scanGift,
    scanGiftExt,
    isScanGiftShow,
    isScanGiftInited,
    isAllScanGiftCouponReceived,
    isAllScanGiftCouponNotReceived,
    receiveScanGiftCoupon,
    onShowState,
    onCompReady,
  };
};
